import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./HomePage";
import OurGallery from "./OurGallery";
import AboutUs from "./AboutUs";
import Contact from "./Contact";
import ComingSoon from "./ComingSoon";
import MyServices from "./MyServices";
import TownHouses from "./TownHouses";
import CustomBuild from "./CustomBuild";
import KnowBuild from "./KnowBuild";
import HomeDesign from "./HomeDesign";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/gallery" element={<OurGallery />} />
         <Route path="/aboutus" element={<AboutUs />} />
         <Route path="/services" element={<MyServices />} />
         <Route path="/contact" element={<Contact />} />
         <Route path="/comingsoon" element={<ComingSoon/>} />
         <Route path="/town" element={<TownHouses/>} />
         <Route path="/home" element={<HomeDesign/>} />
          <Route path="/custom" element={<CustomBuild/>} />
          <Route path="/know" element={<KnowBuild/>} />
      </Routes>
    </Router>
  );
}
export default App;
